import { useEffect, useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { FlagSet } from '@antimatterhq/ui/utils/flags';
import { useGetWorkspaceContext } from '../workspace/useGetWorkspaceContext';

export const useInitializationCheck = () => {
  const { data: workspaceContext, isPending } = useGetWorkspaceContext();
  const navigate = useNavigate();
  const location = useLocation();
  const { enableInitialHousekeepingCheck } = useFlags<FlagSet>();

  useEffect(() => {
    if (!enableInitialHousekeepingCheck) {
      return;
    }
    if (
      !isPending &&
      !workspaceContext?.installationComplete &&
      location.pathname !== '/initialization'
    ) {
      navigate('/initialization');
    }
  }, [
    location,
    workspaceContext,
    isPending,
    navigate,
    enableInitialHousekeepingCheck,
  ]);

  // we want to check this independently of the above check to prevent page flashing
  const initialized = useMemo(() => {
    return (
      enableInitialHousekeepingCheck === false ||
      !!workspaceContext?.installationComplete
    );
  }, [workspaceContext, enableInitialHousekeepingCheck]);

  return {
    initialized,
  };
};
